import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ControlContainer,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ServiceDataFields } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/service-data-fields.enum';
import {
  RadioFormType,
  ServiceDataFormConditionHistoryComponent,
} from '@app/modules/service-data/components/service-data/service-data-form/service-data-form-condition-history/service-data-form-condition-history.component';
import { TranslateModule } from '@ngx-translate/core';
import { controlContainerProvider } from '@shared/helpers';

@Component({
  selector: 'app-sample-patient-history-information',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ServiceDataFormConditionHistoryComponent,
  ],
  templateUrl: './sample-patient-history-information.component.html',
  styleUrl: './sample-patient-history-information.component.scss',
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SamplePatientHistoryInformationComponent implements OnInit {
  private controlContainer = inject(ControlContainer);

  public fieldSet = input.required<string[]>();
  protected get form() {
    return this.controlContainer.control as FormGroup;
  }

  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.initControlChecks();
  }

  private initControlChecks() {
    this.checkControlOnChange(
      'albuminTherapy.hasReceived',
      'albuminTherapy.isRelevant'
    );
    this.checkControlOnChange(
      'cellularImmunotherapy.hasReceived',
      'cellularImmunotherapy.isRelevant'
    );
    this.checkControlOnChange(
      'bloodTransfusion.hasReceived',
      'bloodTransfusion.isRelevant'
    );
  }

  private checkControlOnChange(
    controlNameToCheck: string,
    controlNameToClear: string,
    isArray?: boolean
  ): void {
    if (
      !this.form.get(controlNameToCheck) ||
      !this.form.get(controlNameToClear)
    ) {
      return;
    }

    this.form
      .get(controlNameToCheck)
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: boolean) => {
        if (!value) {
          this.form.get(controlNameToClear).reset(isArray ? [] : null);
        }
      });
  }

  protected readonly ServiceDataFields = ServiceDataFields;
  protected readonly RadioFormType = RadioFormType;
}
